import { get, put, post } from "./client";

export interface PartnerProfile {
  id: string;
  fullName: string;
  email: string;
  phone: string | null;
  socialMediaHandle: "instagram" | "tiktok" | "youtube" | "blog" | null;
  socialMediaUrl: string | null;
  tier: "Nano" | "Micro" | "Macro" | "Mega" | "Startup";
  followersCount: number;
  bankType: "bank" | "e-wallet" | null;
  bankName: string | null;
  bankAccountNumber: string | null;
  bankAccountName: string | null;
  status: "active" | "inactive";
  createdAt: string;
  pendingEmail?: string | null;
}

export interface UpdateProfilePayload {
  fullName?: string;
  phone?: string;
  socialMediaHandle?: "instagram" | "tiktok" | "youtube" | "blog";
  socialMediaUrl?: string;
  followersCount?: number;
  bankType?: "bank" | "e-wallet";
  bankName?: string;
  bankAccountNumber?: string;
  bankAccountName?: string;
}

interface ProfileResponse {
  id: string;
  fullName: string;
  email: string;
  phone: string | null;
  socialMediaHandle: "instagram" | "tiktok" | "youtube" | "blog" | null;
  socialMediaUrl: string | null;
  tier: "Nano" | "Micro" | "Macro" | "Mega" | "Startup";
  followersCount: number;
  bankType: "bank" | "e-wallet" | null;
  bankName: string | null;
  bankAccountNumber: string | null;
  bankAccountName: string | null;
  status: "active" | "inactive";
  createdAt: string;
}

interface UpdateProfileResponse {
  message: string;
  partner: {
    id: string;
    fullName: string;
    email: string;
    phone: string | null;
    socialMediaHandle: "instagram" | "tiktok" | "youtube" | "blog" | null;
    socialMediaUrl: string | null;
    tier: "Nano" | "Micro" | "Macro" | "Mega" | "Startup";
    followersCount: number;
    bankType: "bank" | "e-wallet" | null;
    bankName: string | null;
    bankAccountNumber: string | null;
    bankAccountName: string | null;
  };
}

export async function getPartnerProfile(): Promise<PartnerProfile> {
  return get<ProfileResponse>("/partner/profile");
}

export async function updatePartnerProfile(
  payload: UpdateProfilePayload
): Promise<UpdateProfileResponse> {
  return put<UpdateProfileResponse>("/partner/profile", payload);
}

export async function requestEmailChange(
  newEmail: string
): Promise<{ message: string; pendingEmail: string }> {
  return post("/partner/profile/email/request", { newEmail });
}

export async function verifyEmailChange(
  code: string
): Promise<{ message: string; email: string }> {
  return post("/partner/profile/email/verify", { code });
}

export async function cancelEmailChange(): Promise<{ message: string }> {
  return post("/partner/profile/email/cancel");
}
